import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.InviteTeammateSuggestion', {
    label: 'No access to connect the accounting system?',
    labelInvite: 'Invite your teammate to connect.',
    buttonInvite: 'Invite teammate',
});
